// Het bouwvlak uit het bestemmingsplan, zoals de cube het meegeeft in
// `data.zoningFootprint`: per vlak een naam, de overlap met het perceel (in
// procenten) en de geometrie. Puur en zonder DOM, zodat het te testen is.

import { CodeDataDTO, Cube } from "../../state/types";

export interface FootprintRow {
  // Positie in `data.zoningFootprint`; ook het feature-id op de kaart.
  index: number;
  label: string;
  // Aandeel van het perceel, 0–100, afgerond op hele procenten.
  overlap: number;
  // Oppervlak binnen het perceel in m², afgerond op tientallen.
  areaM2: number;
}

export const footprintEntries = (cube: Cube): CodeDataDTO[] => cube?.data?.zoningFootprint ?? [];

/**
 * Eén rij per bouwvlak. Het oppervlak is overlap × perceeloppervlak
 * (`cube.geometry.properties.area`): de overlap is een berekend percentage,
 * dus meer precisie dan tientallen m² zou schijnzekerheid zijn.
 */
export function footprintRows(cube: Cube): FootprintRow[] {
  const parcelArea = cube?.geometry?.properties?.area ?? 0;
  return footprintEntries(cube).map((entry, index) => ({
    index,
    label: entry.data?.naam || entry.name,
    overlap: Math.round(entry.overlap ?? 0),
    areaM2: Math.round((((entry.overlap ?? 0) / 100) * parcelArea) / 10) * 10,
  }));
}
